// * AXIOS
export const BASE_URL = process.env.REACT_APP_BASE_URL; // * Local BASE URL

// * Vite CONFIG
export const SERVER_URL =  process.env.REACT_APP_SERVER_URL; // * Local Server URL
